import React from 'react';
import PropTypes from 'prop-types';
import BucketHeader from '../containers/header/BucketHeader';
import BucketCover from '../containers/cover/BucketCover';
import BucketAssets from '../containers/BucketAssets';

import isAuthorizedCurrentBucket from '../hoc/CurrentBucketAuthorization';
import { connect } from 'react-redux';
import * as bucketSelectors from '../selectors/bucketSelectors';
import routes from '../helpers/ApplicationRoutes';
import { Redirect } from 'react-router';

class BucketAssetsPage extends React.Component {
    render() {
        const { bucket, application, organizationId } = this.props;

        if (!application || application === 'undefined') {
            return (
                <Redirect
                    to={routes.bucketAssets.getPath({
                        application: bucket.visibleInApplications[0].id,
                        bucketId: bucket.id,
                        organizationId,
                    })}
                />
            );
        }

        return (
            <React.Fragment>
                <BucketHeader />
                <BucketCover />
                <BucketAssets />
            </React.Fragment>
        );
    }
}

BucketAssetsPage.propTypes = {
    bucket: PropTypes.object,
    application: PropTypes.string,
    organizationId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
    bucket: bucketSelectors.getBucket(state, ownProps.match.params.bucketId),
    application: ownProps.match.params.application,
    organizationId: ownProps.match.params.organizationId,
});

export default connect(mapStateToProps)(
    isAuthorizedCurrentBucket(BucketAssetsPage),
);



// WEBPACK FOOTER //
// ./src/pages/BucketAssetsPage.js